import React from "react";
import ReactDOM from "react-dom";
import styled, { css } from "react-emotion";

const Item = styled("div")`
  position: relative;
  display: block;
  float: left;
  width: 20rem;
  height: 20rem;
  overflow: hidden;
`;

const Title = styled("div")`
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
`;

const TitleLink = styled("a")`
  display: block;
  color: #fff;
  text-decoration: none;
  padding: 20px;
  font-size: 16px;
`;

function DownloadItem(props) {
  return (
    <Item>
      <Title>
        <TitleLink href={props.link}>{props.linktitle}</TitleLink>
      </Title>
      <a href={props.link}>
        <img
          className={css({
            display: "block"
          })}
          src={props.image}
        />
      </a>
    </Item>
  );
}

export default DownloadItem;



// WEBPACK FOOTER //
// ./src/components/DownloadItem.js